module.exports = __webpack_public_path__ + "img/horizontal_3_6_r_8019.c84afce3.png";